import { z } from 'zod';
import { productDiscountPercentSchema } from '../const/productDiscountPercentSchema';
import { productDiscountTypeSchema } from '../const/productDiscountTypeSchema';

export const productDiscountInputSchema = z.object({
    originalRaw: z.number().int().positive(),
    discountType: productDiscountTypeSchema,
    discountPercent: productDiscountPercentSchema,
});

export type ProductDiscountInputSchema = z.infer<typeof productDiscountInputSchema>;
